export const MASTERBASEURL = 'https://boss.evisioneand.com'